import {
  APIConnectionConfig,
  ModuleConfig,
  ModuleDisplayConfig,
  ModuleMapConfig,
} from '@schamburg-web/interfaces';
import TravelTimesMarker, { TravelTimesMapMarker } from './TravelTimesMarker';
import TTDisplayCard from './TTDisplayCard';

export const travelTimesIcon = '/mapicons/delay.svg';

const mapModuleConfig: ModuleMapConfig = {
  zIndex: 90,
  layerIcon: travelTimesIcon,
  showOnMap: true,
  defaultEnabled: true,
};

const displayConfig: ModuleDisplayConfig = {
  label: 'Travel Times',
  isPopupDialog: false,
  isMobilePopupDialog: true,
  isOnSideBar: true,
  popupDef: TTDisplayCard,
  cardDef: TTDisplayCard,
  markerDef: TravelTimesMapMarker,
};

const apiConfig: APIConnectionConfig = {
  endpoint: 'tt',
  updateDelay: 0,
  publishLayer: 'tt',
};

const moduleConfig: ModuleConfig = {
  name: 'traveltimes',
  moduleLabel: 'Travel Times',
  mapConfig: mapModuleConfig,
  displayConfig: displayConfig,
  apiConfig: apiConfig,
};

export default moduleConfig;
